'use strict';
(function() {
    angular.module('cvsApp').directive('storeList', ['cvsAppData', function(CAD) {
        return {
            restrict: 'E',
            templateUrl: '../storelocator/app/components/storeList/storeList.html',
            scope: {
                data: '=',
                currentindex: '=',
                store: '=',
            },        
            controller: ['$scope', 'manageFavoriteStoresService', '$state', 'checkFavoriteStore',
                '$cookies', 'PagerService', 'checkStoreopen', '$window','validation','$controller','$rootScope','webTrendsService',
                'retrieveTimeStampService', '$uibModal',
                function($scope, MFS, $state, CFS, $cookies, PagerService, checkStoreopen, $window, VF, $controller, $rootScope, WTS, RTSS, $uibModal) {
                    $scope.$root.$on('$messageIncoming', function (event, e) {
                        console.log(`Message from parent`, e);
                    });
                    $scope.SL = this;
                    $scope.SL.showStore = [];
                    //$scope.SL.favid = CFS.favouriteStoreId;
                    $scope.SL.isMobile = cvsUtility.isMobile();
                    $scope.SL.favCookieStore = $cookies.get('favCookieStore');
                    $scope.SL.tokenID = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                    $scope.SL.token = cvsUtility.queryMap.token;
                    $scope.SL.reviewStore = CAD.getReviewOrder();
                    $scope.SL.storeVisibility = CAD.getStoreListVisiblity();
                    var storeId, itemToBeAdded;
                    RTSS.retrieveTimeStamp(onServerTimeStampSuccess);

                    function onServerTimeStampSuccess (data) {
                        if(data.SERVER_ERROR){

                            var pageError = cvsUtility.getPageError(data, 'NonFatal', 'retrieveTimeStamp');
                            WTS.webTrendsUtag("LINK",{ page_error: pageError},undefined);
                            var date=new Date();
                            // $rootScope.serverTimeStamp=date.toUTCString();
                        }

                        if(data.getError() === '') {
                            $rootScope.serverTimeStamp = data.apiResponse.timeStamp?data.apiResponse.timeStamp:'';
                            if($rootScope.serverTimeStamp && typeof $rootScope.serverTimeStamp === "object"){
                                $rootScope.serverTimeStamp.__text = $rootScope.serverTimeStamp.__text.replace(/[\n\t\r]+/g,'');
                            }
                            else{
                                $rootScope.serverTimeStamp = $rootScope.serverTimeStamp.replace(/[\n\t\r]+/g,'');
                            }

                        }else{
                            /**
                             * sankar 02/10/2016 - SMP 009 - retrieveTimeStamp service error
                             * Modified page_error tag
                             */
                            var pageError = cvsUtility.getPageError(data, 'NonFatal', 'retrieveTimeStamp');
                            WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                        }

                    }
                    $scope.SL.getDetails = function(item, $event) {
                       $rootScope.triggerElementId=$event.currentTarget.id;
                        if($scope.SL.reviewStore){
                            $rootScope.showStoreDetailsView = true;
                            $rootScope.showStoreDetailsItem = item;
                            //$rootScope.$apply();
                        }
                        else{
                        $state.transitionTo('store-detail', {
                            storeNumber: item.content.properties.EntityID.__text,
                            distance: item.content.properties.hasOwnProperty('__Distance')? item.content.properties.__Distance.__text : null
                        });
                        }
                    };
                    $scope.SL.getDirection = function(store, storenumber) {
                        var stringifiedStore = JSON.stringify(store);
                        if (cvsUtility.setNativeCheck()) {
                            native.locateStoreInMap(stringifiedStore);
                        }
                        else if(cvsUtility.isMobile()){
                            var popupWindow =  window.open('http://maps.apple.com/?q='+store.content.properties.AddressLine.__text+','+store.content.properties.Locality.__text+','+store.content.properties.AdminDistrict.__text+','+store.content.properties.PostalCode.__text);
                            setTimeout(function(){
                                popupWindow.close();
                            }, 5000);
                        }
                        else {
                            $state.transitionTo('store-direction', {
                                storeNumber: storenumber
                            });
                        }
                    }
                    $scope.SL.openTel = function(number) {
                        var origVal = number.replace(/[^\w\s]/gi, '');
                        var str, phone;
                        if (origVal.length === 10) {
                            str = origVal.replace(/(.{3})/g, "$1-");
                            phone = str.slice(0, -2) + str.slice(-1);
                        }
                        if (cvsUtility.setNativeCheck()) {
                            native.openExtUrl('tel:' + phone);
                        } else {
                            $window.open('tel:' + phone)
                        }

                    }
                    $scope.SL.getDefaultStoreTiming = function(date, store) {
                        if (store && store.content) {
                            switch (date) {
                                case 7:
                                    return store.content.properties.Rx_Sun_Hours.__text;
                                    break;
                                case 1:
                                    return store.content.properties.Rx_Mon_Hours.__text;
                                    break;
                                case 2:
                                    return store.content.properties.Rx_Tues_Hours.__text;
                                    break;
                                case 3:
                                    return store.content.properties.Rx_Wed_Hours.__text;
                                    break;
                                case 4:
                                    return store.content.properties.Rx_Thur_Hours.__text;
                                    break;
                                case 5:
                                    return store.content.properties.Rx_Fri_Hours.__text;
                                    break;
                                default:
                                    return store.content.properties.Rx_Sat_Hours.__text;
                                    break;
                            }
                        }
                    };
                    $scope.SL.getDefaultStoreHrs = function(date, store) {
                        if (!store.content) {
                            return false;
                        }
                        switch (date) {
                            case 7:
                                return store.content.properties.Fs_Sun_Hours.__text;
                                break;
                            case 1:
                                return store.content.properties.Fs_Mon_Hours.__text;
                                break;
                            case 2:
                                return store.content.properties.Fs_Tues_Hours.__text;
                                break;
                            case 3:
                                return store.content.properties.Fs_Wed_Hours.__text;
                                break;
                            case 4:
                                return store.content.properties.Fs_Thur_Hours.__text;
                                break;
                            case 5:
                                return store.content.properties.Fs_Fri_Hours.__text;
                                break;
                            default:
                                return store.content.properties.Fs_Sat_Hours.__text;
                                break;
                        }
                    };

                    $scope.SL.checkOpen = function(item, pharOrStore) {
                        var openStatus = $rootScope.checkOpen(item,pharOrStore);

                        if(openStatus){
                            return true;
                         }else{
                            return false;
                    }
                    }

                    $scope.SL.selectStoreReviewOrder = function(items){
                        $scope.SL.selectedStore=items;
                        $scope.SL.selectAddress=true;
                        var validateAddressResult=VF.validateStorePickUpAddress(items);
                        if(validateAddressResult!==""){
                            $scope.$parent.$parent.$resolve.parentScope.selectedStore.selectStore=true;
                            $scope.$parent.$parent.$resolve.parentScope.ERROR={"SERVER_ERROR":true,"ERROR_MSG":validateAddressResult};
                            $scope.$parent.$parent.$resolve.parentScope.selectedStore.selectedStore=$scope.SL.selectedStore;
                            $scope.$parent.$parent.$resolve.parentScope.pickOrDel="pickup";
                            if($scope.$parent.$parent.$resolve.parentScope.selectedStore.selectStore){
                                $scope.$parent.$parent.$resolve.parentScope.pickOrDel="delivery";
                                $scope.$parent.$parent.$resolve.parentScope.selectedStore.selectStore=true;
                            }
                            //deliveryDetailsScope.closePopUP();
                            $scope.$parent.$parent.closePopUP()
                        }else{
                            //if(deliveryDetailsScope){
                                items = JSON.parse(JSON.stringify(items));
                                parent.postMessage(items, "*");
                                $scope.$parent.$parent.$resolve.parentScope.selectedStore.selectedStore = $scope.SL.selectedStore;
                                $scope.$parent.$parent.$resolve.parentScope.selectStore = false;
                                $scope.$parent.$parent.$resolve.parentScope.pickOrDel = "pickup";
                                $scope.$parent.$parent.closePopUP();
                                //deliveryDetailsScope.closePopUP();
                    //}
                        }
                    }

                    $scope.SL.checkinFav = function(storenumber) {
                        if (!$scope.SL.tokenID && $scope.SL.favCookieStore) {
                            var cookesItems = $cookies.get('favCookieStore');
                            if (cookesItems.length > 0) {
                                for (var i = 0; i < cookesItems.length; i++) {
                                    if (cookesItems[i].favCookieStore.storeNumber === storenumber) {
                                        return true;
                                    }
                                }
                            }
                        } else if ($scope.SL.tokenID) {
                            var favStores = CAD.getFavStores();

                            if (favStores.length > 0) {
                                for (var i = 0; i < favStores.length; i++) {
                                    if (favStores[i] && favStores[i].content && favStores[i].content.properties.EntityID.__text === storenumber) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    }

                    $scope.SL.selectStore = function(item) {

                        angular.element("#specialtySpinner").show();
                        angular.element("#loader").show();
                        storeId = item.content.properties.EntityID.__text;
                        itemToBeAdded = item;
                        var lati = item.content.properties.Latitude.__text.replace(/[\n\t\r]+/g,'');
                        var longi = item.content.properties.Longitude.__text.replace(/[\n\t\r]+/g,'');
                        var array = [];
                        var utagObj = {};
                        utagObj.page_name = "Search results";
                        utagObj.store_id = storeId;
                        utagObj.link_name = 'Custom: User Set My CVS';
                        WTS.webTrendsUtag("LINK", utagObj);
                        if ($scope.SL.tokenID) {
                            MFS.addFavoriteStore(addressAdded, '', 'addStore', storeId);
                        } else {
                            array = [];
                            array.push({
                                'favCookieStore': {
                                    storeNumber: storeId,
                                    Latitude: lati,
                                    Longitude: longi
                                }
                            });
                            $cookies.put('favCookieStore', array);
                            $scope.SL.favCookieStore = $cookies.get('favCookieStore');
                        }

                    }

                    $scope.SL.deleteStore = function(item) { // added to sl
                        angular.element("#specialtySpinner").show();
                        angular.element("#loader").show();
                        storeId = item.content.properties.EntityID.__text;
                        if ($scope.SL.tokenID) {
                            MFS.addFavoriteStore(addressDeleted, '', 'deleteStore', storeId);
                        } else {
                             $cookies.put('favCookieStore', []);
                        }

                    }

                    function addressDeleted(response) {
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                        if(response && (response.SERVER_ERROR || response.getError() !== '')){
                            var pageError = cvsUtility.getPageError(response, 'Fatal', 'manageFavoriteStores');
                            WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                            if(response.getError() !== '' && response.getError().hasOwnProperty('statusDesc')){
                                alert(response.getError().statusDesc);
                            }
                            return;
                        }
                            var favStores = CAD.getFavStores();

                            if (favStores.length > 0) {
                                for (var i = 0; i < favStores.length; i++) {
                                    if (favStores[i].content.properties.EntityID.__text === storeId) {
                                        favStores.splice(i, 1);
                                    }
                                }
                            }
                            CAD.setFavStores(favStores)
                           // console.log("$scope", $scope);
                            $scope.$parent.$parent.$parent.$parent.SLC.FavStores = CAD.getFavStores();
                    }



                    function addressAdded(response) {
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                        if(response && (response.SERVER_ERROR || response.getError() !== '')){
                            var pageError = cvsUtility.getPageError(response, 'Fatal', 'manageFavoriteStores');
                            WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                            if(response.getError() !== '' && response.getError().hasOwnProperty('statusDesc')){
                                alert(response.getError().statusDesc);
                            }
                            return;
                        }
                        CAD.pushFavStore(itemToBeAdded);
                    }
                }
            ]
        }
    }])
})();